import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@salestrak/ui";
import { PageHeader } from "#app/components/page-header";
import { IssuesTable } from "#app/components/issues/issues-table";
import { IssueFilterProvider } from "#app/lib/filters/issue-filter-context";
import { AnalyticsScope } from "#app/lib/analytics";
import { useMemberLabelResolver } from "#app/lib/data/member-directory-provider";

/**
 * `/member/$memberId` — a single member's assigned projects across every
 * workflow, rendered by the shared {@link IssuesTable} scoped to the member.
 */
function MemberDetail() {
  const { memberId } = Route.useParams();
  const resolveMemberLabel = useMemberLabelResolver();
  return (
    <IssueFilterProvider analyticsScope={AnalyticsScope.Member}>
      <MemberInner
        memberId={memberId}
        title={resolveMemberLabel(memberId) ?? "Member"}
      />
    </IssueFilterProvider>
  );
}

function MemberInner({ memberId, title }: { memberId: string; title: string }) {
  return (
    <Box direction="column" fill="flex">
      <PageHeader title={title} />
      <IssuesTable scope={{ kind: "member", memberId }} />
    </Box>
  );
}

export const Route = createFileRoute("/(app)/$workspace/member/$memberId/")({
  component: MemberDetail,
});
